export const SUPPORTED_LOCALES = [
    { id: 'en-US', text: 'English' },
    { id: 'ja-JP', text: '日本語' },
] as const;

export const DEFAULT_LOCALE = SUPPORTED_LOCALES.find((locale) => locale.id === 'en-US')!;
